import React, { useMemo } from 'react';

import Banner from '@atlaskit/banner';
import InfoIcon from '@atlaskit/icon/glyph/info';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

import { Allowance, Repository } from 'src/components/pipelines/models';

import { ORIGIN } from '../const';

import { BannerContentWrapper } from './styled';

type Props = {
  allowance: Allowance;
  repository: Repository;
};

const QuotaBanner = ({ allowance, repository }: Props) => {
  const getQuota = useMemo(() => {
    return allowance.quota !== -1 && allowance.quota.toLocaleString();
  }, [allowance.quota]);

  const getPlansPageUrl = useMemo(() => {
    const workspaceSlug = repository.getWorkplaceSlug();
    return `${ORIGIN}/${workspaceSlug}/workspace/settings/plans-and-billing/`;
  }, [repository]);

  return (
    <Banner appearance="announcement">
      <BannerContentWrapper>
        <InfoIcon
          primaryColor={token('color.icon.inverse', colors.N0)}
          secondaryColor={token('color.icon', 'black')}
          label="Info"
        />
        {getQuota ? (
          <p>
            We&apos;re offering <b>{getQuota}</b> build minutes per month for
            your current plan.{' '}
            <a href={getPlansPageUrl} target="_top">
              <b>See upgrade options</b>
            </a>
          </p>
        ) : (
          <p>
            Your{' '}
            <a href={getPlansPageUrl} target="_top">
              Bitbucket plan
            </a>{' '}
            includes free minutes.
          </p>
        )}
      </BannerContentWrapper>
    </Banner>
  );
};

export default React.memo(QuotaBanner);
